/**
 * The fonts a report can be set in, in one place.
 *
 * The values are PDFKit's core-font names because that renderer can only use
 * those fourteen faces; the DOCX renderer maps them to real Word family names
 * (Helvetica -> Arial, Times-Roman -> Times New Roman) via docxFontFor, since
 * Windows has no Helvetica and would silently substitute something else.
 *
 * This list was duplicated in HeaderFooterEditor and PageSettingsPanel, and a
 * third copy was about to be added for text blocks and tables. Adding a face
 * should be one edit, not four that drift.
 */

const FONT_OPTIONS = [
  { value: 'Helvetica', label: 'Helvetica / Arial' },
  { value: 'Times-Roman', label: 'Times New Roman' },
  { value: 'Courier', label: 'Courier New' },
  { value: 'Calibri', label: 'Calibri' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Tahoma', label: 'Tahoma' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS' },
  { value: 'Garamond', label: 'Garamond' },
  { value: 'Palatino', label: 'Palatino' },
];

/**
 * For a control that may defer to the template. The empty value means "not
 * set here", which is what the renderers read as falling through to the
 * template's body font -- distinct from picking the same face explicitly,
 * because changing the template later should carry.
 */
const FONT_OPTIONS_INHERIT = [{ value: '', label: 'Default (template)' }, ...FONT_OPTIONS];

/** What the editor preview should actually paint for a chosen value. */
const CSS_FONT_STACKS = {
  'Helvetica': 'Helvetica, Arial, sans-serif',
  'Times-Roman': '"Times New Roman", Times, serif',
  'Courier': '"Courier New", Courier, monospace',
  'Calibri': 'Calibri, Candara, Segoe, sans-serif',
  'Georgia': 'Georgia, serif',
  'Verdana': 'Verdana, Geneva, sans-serif',
  'Tahoma': 'Tahoma, Geneva, sans-serif',
  'Trebuchet MS': '"Trebuchet MS", Helvetica, sans-serif',
  'Garamond': 'Garamond, Baskerville, serif',
  'Palatino': 'Palatino, "Palatino Linotype", serif',
};

function cssFontFor(value, fallback) {
  if (!value) return fallback;
  return CSS_FONT_STACKS[value] || value;
}

export { FONT_OPTIONS, FONT_OPTIONS_INHERIT, CSS_FONT_STACKS, cssFontFor };
export default FONT_OPTIONS;
